import { render, staticRenderFns } from "./event-card-item.vue?vue&type=template&id=79dc9892&scoped=true&"
import script from "./event-card-item.vue?vue&type=script&lang=js&"
export * from "./event-card-item.vue?vue&type=script&lang=js&"
import style0 from "./event-card-item.vue?vue&type=style&index=0&id=79dc9892&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dc9892",
  null
  
)

/* custom blocks */
import block0 from "./event-card-item.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports